import { sentryService } from "./service";

export const USER_FACING_ERROR_SCREEN_MESSAGE =
  "User-facing error screen shown";

export const USER_FACING_ERROR_TAG = "true";

export type UserFacingErrorScreenId =
  | "case-load"
  | "case-preview"
  | "hipaa-release"
  | "onboarding-resume"
  | "person-list"
  | "flow-create-case"
  | "activate"
  | "web-crash"
  | "native-crash";

export type UserFacingErrorSourceId =
  | "apollo"
  | "error-boundary"
  | "route"
  | "preview"
  | "sign"
  | "network"
  | "bug"
  | "unknown";

export type UserFacingErrorScreenReport = {
  screen: UserFacingErrorScreenId;
  source: UserFacingErrorSourceId;
  error?: Error;
  attempt?: number;
};

export function reportUserFacingErrorScreen(
  report: UserFacingErrorScreenReport,
): string | undefined {
  const userFacingError = report.error
    ? new Error(USER_FACING_ERROR_SCREEN_MESSAGE, { cause: report.error })
    : new Error(USER_FACING_ERROR_SCREEN_MESSAGE);

  return sentryService.captureException(userFacingError, {
    tags: {
      userFacingError: USER_FACING_ERROR_TAG,
      errorScreen: report.screen,
      errorSource: report.source,
    },
    // Without a cause every marker shares this message and stack, so default
    // grouping would collapse every screen into one issue.
    ...(report.error
      ? {}
      : {
          fingerprint: [
            "user-facing-error-screen",
            report.screen,
            report.source,
          ],
        }),
  });
}
